var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("CenterForSorting.bulkImport"),
        visible: _vm.importDialog,
        "custom-class": "bulk-import-dialog",
        top: "5vh",
        width: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.importDialog = $event
        },
        close: _vm.handleDialog,
      },
    },
    [
      !_vm.showResult
        ? _c("div", [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("CenterForSorting.uploadRuleFile"))),
            ]),
            _c(
              "div",
              { staticClass: "upload-section flx-center" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      "auto-upload": false,
                      "on-change": _vm.handleFileChange,
                      "show-file-list": false,
                      accept:
                        ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                      action: "#",
                      drag: "",
                    },
                  },
                  [
                    _c("div", { staticClass: "upload-content" }, [
                      _c("i", { staticClass: "el-icon-plus upload-icon" }),
                      _c("div", { staticClass: "upload-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CenterForSorting.dragOrClickUpload"))
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm.fileName
              ? _c("div", { staticClass: "file-preview" }, [
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(_vm.fileName)),
                  ]),
                  _c("i", {
                    staticClass: "el-icon-circle-close file-delete",
                    on: { click: _vm.delFile },
                  }),
                ])
              : _vm._e(),
            _c("div", { staticClass: "template-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("CenterForSorting.ruleTemplateDownload"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "template-download",
                  on: { click: _vm.downLoadFile },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("CenterForSorting.downloadTemplate"))),
                  ]),
                  _c("i", { staticClass: "el-icon-download download-icon" }),
                ]
              ),
            ]),
          ])
        : _c("div", { staticClass: "result-section" }, [
            _c("div", { staticClass: "result-stats" }, [
              _c("div", { staticClass: "stat-item" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("CenterForSorting.totalRows"))),
                ]),
                _c("span", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.resultData.totalRowCount)),
                ]),
              ]),
              _c("div", { staticClass: "stat-item success" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("CenterForSorting.successCount"))),
                ]),
                _c("span", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.resultData.successRowCount)),
                ]),
              ]),
              _c("div", { staticClass: "stat-item fail" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("CenterForSorting.failCount"))),
                ]),
                _c("span", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.resultData.failRowCount)),
                ]),
              ]),
            ]),
            _vm.resultData.failRowCount > 0
              ? _c(
                  "div",
                  { staticClass: "error-list" },
                  [
                    _c("div", { staticClass: "section-title" }, [
                      _vm._v(_vm._s(_vm.$t("CenterForSorting.failReason"))),
                    ]),
                    _c(
                      "el-scrollbar",
                      { staticClass: "error-scrollbar" },
                      _vm._l(_vm.resultData.errors, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "error-item" },
                          [
                            _c("span", { staticClass: "error-msg" }, [
                              _vm._v(_vm._s(item.message)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { size: "small" },
              on: { click: _vm.handleDialog },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.showResult
                      ? _vm.$t("CenterForSorting.close")
                      : _vm.$t("CenterForSorting.cancel")
                  ) +
                  " "
              ),
            ]
          ),
          !_vm.showResult
            ? _c(
                "el-button",
                {
                  staticClass: "btn-confirm",
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.confirmImport },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.confirmUpload")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }